module.exports = __webpack_public_path__ + "img/sj_meijiao.ce5baf93.jpg";